<template>
  <div class="control_point">
    <div class="control_point-overlay" @click="switchControlPointModal"></div>
    <div class="control_point-card">
      <div class="card-header">
        <div class="card-title">
          <ccs-input class="title-text" type="textarea" :modifiers="['big', 'active_only', 'auto_expand']"
            v-model.trim="localControlPoint.name" placeholder="Введите название" :readOnly="isReadOnly"/>
          <button class="title-action title-action--delete" v-if="isEditing && !isChanged && permissionsStatus.isControlPointDeleteAllowed"
            @click="removeControlPoint">
            Удалить
          </button>
          <button class="title-action" v-if="isEditing && isChanged && permissionsStatus.isControlPointUpdateAllowed" @click="changeControlPoint">
            Сохранить
          </button>
          <button class="title-action" v-if="isEditing && isChanged
            && !permissionsStatus.isControlPointUpdateAllowed
            && isControlPointRequestAllowed"
            @click="addControlPointRequest">
            Создать заявку
          </button>
          <button class="title-action" v-if="!isEditing" @click="addControlPoint">
            Создать
          </button>
        </div>
      </div>
      <div class="card-tags" v-if="isEditing">
        <div v-if="!localControlPoint.completed_at && (new Date(localControlPoint.expired_at)) - Date.now() <= 0"
          class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--danger ccs-tag--no_action">
          Срок истек
        </div>
        <div v-if=" !localControlPoint.completed_at &&
          new Date(localControlPoint.expired_at).getTime() - Date.now() < 604800000 &&
          new Date(localControlPoint.expired_at).getTime() - Date.now() > 0"
          class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--warn ccs-tag--no_action">
          Истекает срок
        </div>
      </div>
      <div class="card-body">
        <div class="body-block">
          <div class="card-info">
            <div class="info-row">
              <div class="info-title">Тип</div>
              <ccs-input class="info-value" type="dropdown"
                v-model="localControlPoint.type" :items="controlPointTypeItems" :readOnly="isEditing && !permissionsStatus.isControlPointUpdateAllowed"
                :modifiers="['no_cancel', 'active_only']"/>
            </div>
            <div class="info-row" v-if="isEditing">
              <div class="info-title">Статус</div>
              <ccs-input class="info-value" type="dropdown" :items="controlPointStatuses"
                v-model="localControlPoint.execution_status"
                :readOnly="!permissionsStatus.isControlPointStatusAllowed && isReadOnly || isInClosureProcessAndUserNotAdmin"
                :modifiers="['no_cancel', 'active_only']" @select="changeControlPointStatus"/>
            </div>
            <div class="info-row">
              <div class="info-title">Срок</div>
              <ccs-input class="info-value" type="date" :readOnly="isReadOnly || !!localControlPoint.completed_at"
                v-model="localControlPoint.expired_at" :modifiers="['active_only']"/>
            </div>
            <div class="info-row" v-if="localControlPoint.completed_at">
              <div class="info-title">Завершена</div>
              <ccs-input class="info-value" type="date" :readOnly="true"
                v-model="localControlPoint.completed_at" :modifiers="['active_only']"/>
            </div>
            <div class="info-row">
              <div class="info-title">Описание</div>
              <ccs-input class="info-value" type="textarea" placeholder="Введите описание" :readOnly="isReadOnly"
                v-model="localControlPoint.description" :modifiers="['auto_expand', 'active_only']"/>
            </div>
            <div class="info-row">
              <div class="info-title">Код ФНД</div>
              <ccs-input class="info-value" type="autocomplete" :items="fndsForSelect"
                v-model="localControlPoint.fnd_id" placeholder="Найти ФНД"
                :readOnly="!permissionsStatus.isControlPointUpdateAllowed" :modifiers="['active_only']"
                @change="onFndSearch" @select="fillExecutorAndResponsible"/>
            </div>
            <div class="info-row">
              <div class="info-title">Организация</div>
              <ccs-input class="info-value" type="autocomplete" :items="organizationsForSelect"
                v-model="localControlPoint.fnd_organization_id" placeholder="Найти организацию"
                :readOnly="!permissionsStatus.isControlPointUpdateAllowed" :modifiers="['active_only']"
                @change="onOrganizationSearch" @select="fillExecutorAndResponsible"/>
            </div>
          </div>
          <div class="card-discussion" v-if="isEditing">
            <div class="discussion-title">Обсуждение</div>
            <div class="discussion-input">
              <ccs-input class="input-field" type="textarea" placeholder="Новое сообщение"
                v-model="message.comment"/>
              <div class="input-buttons">
                <div class="ccs-button ccs-6" v-if="!this.message.id"
                  :class="{ 'ccs-button--blight': message.comment.length === 0 }" @click="createNewMessage">
                  Отправить
                </div>
                <div class="ccs-button" v-else @click="updateMessage">
                  Изменить
                </div>
                <ccs-input class="ccs-6" type="file" label="" v-if="!this.message.id"
                  v-model="message.file" accept="*" :modifiers="['zero_label']" allowFileDelete/>
                <div class="ccs-button ccs-button--light ccs-6" v-if="this.message.id" @click="resetMessage">Отменить</div>
              </div>
            </div>
            <div class="discussion-messages">
              <div class="discussion-message" v-for="attachment in localControlPoint.attachments.data"
                :key="`attachment-${attachment.id}`">
                <div class="message-header">
                  <div class="message-sender">{{ attachment.author.full_name }}</div>
                </div>
                <div class="message-content">
                  <div class="message-text">
                    {{ attachment.comment }}
                  </div>
                  <div class="message-actions">
                    <v-icon v-if="attachment.files && attachment.files.data[0]"
                      class="ccs-icon--primary ccs-icon--hover" name="file" scale="0.9"
                      @click="openFileLink(attachment.files.data[0].url)"/>
                    <v-icon v-if="attachment.author.id === user.id || rolesStatus.isAdmin"
                      class="ccs-icon--primary ccs-icon--hover" name="edit"
                      @click="setMessage(attachment)"/>
                    <v-icon v-if="attachment.author.id === user.id || rolesStatus.isAdmin"
                      class="ccs-icon--secondary ccs-icon--hover" name="trash" scale="0.9"
                      @click="deleteMessage(attachment.id)"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="body-block">
          <div class="card-relations" v-if="localControlPoint.dependent.data.length > 0">
            <div class="relations-title">Зависит от</div>
            <div class="relations-list">
              <div class="relation" v-for="related in localControlPoint.dependent.data" :key="`relate-${related.id}`"
                @click="openControlPointByID(related.id)">
                {{ related.name }}
              </div>
            </div>
          </div>
          <div class="card-relations" v-if="isEditing &&
              (permissionsStatus.isControlPointUpdateAllowed || localControlPoint.affected.data.length > 0)">
            <div class="relations-title">Влияет на</div>
            <div class="relations-list">
              <div class="relation" :class="{ 'relation--delete': permissionsStatus.isControlPointUpdateAllowed }"
                v-for="related in localControlPoint.affected.data" :key="`affect-${related.id}`"
                @click="deleteRelation(related.id)">
                {{ related.name }}
              </div>
            </div>
            <div class="relations-action" v-if="isRelationAddFieldDisabled && this.permissionsStatus.isControlPointUpdateAllowed"
              @click="setRelationAddFieldState(false)">Добавить</div>
            <ccs-input v-if="!isRelationAddFieldDisabled"
              class="relations-input" type="autocomplete" :items="controlPointsForSelect"
              v-model="relativeControlPoint" @change="onControlPointSearch" placeholder="Найти КТ"
              @select="addRelation" @unfocus="setRelationAddFieldState(true)"
              :modifiers="['minimal']"/>
          </div>
          <div class="card-user">
            <div class="user-title">Ответственный</div>
            <template>
              <ccs-input class="user" type="autocomplete" :items="responsiblesForSelect"
                v-model="localControlPoint.responsible_id" @change="onResponsibleSearch"
                placeholder="Найти пользователя" :modifiers="['minimal']"
                :readOnly="!permissionsStatus.isControlPointUpdateAllowed ||
                !localControlPoint.fnd_id || !localControlPoint.fnd_organization_id"
                :disabled="!localControlPoint.fnd_id || !localControlPoint.fnd_organization_id"/>
            </template>
          </div>
          <div class="card-user">
            <div class="user-title">Исполнитель</div>
            <template>
              <ccs-input class="user" type="autocomplete" :items="executorsForSelect"
                v-model="localControlPoint.executor_id" @change="onExecutorSearch"
                placeholder="Найти пользователя" :modifiers="['minimal']"
                :readOnly="!permissionsStatus.isControlPointUpdateAllowed ||
                !localControlPoint.fnd_id || !localControlPoint.fnd_organization_id"
                :disabled="!localControlPoint.fnd_id || !localControlPoint.fnd_organization_id"/>
            </template>
            <div class="user-action" v-if="isDelegateFieldDisabled && isDelegateAllowed && localControlPoint.responsible_id && localControlPoint.executor_id"
             @click="setDelegateFieldState(false)">Делегировать</div>
            <ccs-input v-if="!isDelegateFieldDisabled"
                class="user-input" type="autocomplete" :items="delegatesForSelect"
                v-model="delegateUser" placeholder="Найти пользователя" @change="onDelegateSearch"
                @select="delegateExecution" @unfocus="setDelegateFieldState(true)"
                :modifiers="['minimal']"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

import { executeApiGetRequest } from '@/helpers/api-requests';

import AutocompleteParent from '@/mixins/AutocompleteParent.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'ControlPoint',
  mixins: [AutocompleteParent],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      fndsForSelectRaw: [],
      fndsForSelect: [],
      responsiblesForSelect: [],
      executorsForSelect: [],
      controlPointsForSelect: [],
      delegatesForSelect: [],
      organizationsForSelect: [],
      isRelationAddFieldDisabled: true,
      relativeControlPoint: undefined,
      isDelegateFieldDisabled: true,
      delegateUser: undefined,
      message: {
        id: null,
        comment: '',
        file: null
      },
      availableFields: ['name', 'expired_at', 'description', 'type', 'execution_status'],
      controlPointTypeItems: [{
        prop: 'critical',
        text: 'Критическая'
      }, {
        prop: 'functional',
        text: 'Функциональная'
      }],
      localControlPoint: {
        id: undefined,
        fnd_id: undefined,
        fnd_organization_id: undefined,
        responsible_id: undefined,
        executor_id: undefined,
        name: '',
        description: '',
        execution_status: undefined,
        type: 'critical',
        created_at: new Date(),
        updated_at: new Date(),
        expired_at: new Date(),
        approved_at: new Date(),
        dependent: { data: [] },
        affected: { data: [] },
        attachments: { data: [] },
        fnd: {
          id: 0,
          name: '',
          code: '',
          description: '',
          created_at: new Date(),
          updated_at: new Date(),
          employees: { data: [] },
        }
      }
    }
  },
  computed: {
    ...mapState('projects', ['controlPoint', 'project']),
    ...mapState('session', ['user']),
    ...mapState('events', ['event']),
    ...mapGetters('session', ['rolesStatus', 'permissionsStatus']),
    isEditing() {
      return !!(this.controlPoint && this.controlPoint.id);
    },
    isChanged() {
      if (!this.isEditing) return true
      let result = false;
      this.availableFields.forEach(key => {
        if (!result && this.localControlPoint[key] !== this.controlPoint[key]) {
          result = true;
        }
      });
      if (!result && this.localControlPoint.fnd_id && this.localControlPoint.fnd_id !== this.controlPoint.fnd.id) {
        result = true
      }
      if (!result && this.localControlPoint.responsible_id &&
        this.localControlPoint.responsible_id !== this.controlPoint.responsible.id) {
        result = true
      }
      if (!result && this.localControlPoint.executor_id &&
        this.localControlPoint.executor_id !== this.controlPoint.executor.id) {
        result = true
      }
      return result;
    },
    isInClosureProcessAndUserNotAdmin() {
      return this.controlPoint.execution_status === 'in_closure_process' && !this.rolesStatus.isAdmin;
    },
    isReadOnly() {
      return !(this.permissionsStatus.isControlPointUpdateAllowed || this.isControlPointRequestAllowed);
    },
    isDelegateAllowed() {
      return (this.isEditing &&  this.rolesStatus.isAdmin) ||
        (this.permissionsStatus.isControlPointDelegateAllowed &&
         this.localControlPoint.responsible_id === this.user.id && !this.isInClosureProcessAndUserNotAdmin);
    },
    isControlPointRequestAllowed() {
      return this.controlPoint.execution_status === 'waiting_for_approval'  &&
        this.controlPoint.type !== 'critical' &&
        this.permissionsStatus.isControlPointRequestCreateAllowed;
    },
    controlPointStatuses() {
      return [{
        prop: 'waiting_for_approval',
        text: 'Ожидает подтверждения',
        isSelectable: this.permissionsStatus.isControlPointAllStatusAllowed,
      }, {
        prop: 'in_progress',
        text: 'Выполняется'
      }, {
        prop: 'in_closure_process',
        text: 'В процессе закрытия',
        isSelectable: false,
      },{
        prop: 'completed',
        text: 'Завершена'
      }];
    },
  },
  methods: {
    ...mapMutations('projects', ['switchControlPointModal']),
    ...mapActions('projects', [
      'createControlPoint',
      'updateControlPoint',
      'deleteControlPoint',
      'openControlPointByID',
      'addInfluenceToControlPoint',
      'deleteInfluenceFromControlPoint',
      'setControlPointStatus',
      'delegateControlPoint',
      'createControlPointRequest',
      'getControlPointByID',
      'createAttachment',
      'updateAttachment',
      'deleteAttachment',
    ]),
    ...mapActions('session', ['uploadFile']),
    setLocalControlPoint(controlPoint) {
      if (controlPoint && controlPoint.id) {
        this.localControlPoint = Object.assign(this.localControlPoint, controlPoint);
        if (controlPoint.fnd) {
          this.localControlPoint.fnd_id = controlPoint.fnd.id;
          this.fndsForSelect = [{
            prop: controlPoint.fnd.id,
            displayText: controlPoint.fnd.code,
            searchText: controlPoint.fnd.code,
          }];
        }
        if (controlPoint.responsible) {
          this.localControlPoint.responsible_id = controlPoint.responsible.id;
          this.responsiblesForSelect.push({
            prop: controlPoint.responsible.id,
            displayText: controlPoint.responsible.full_name,
            searchText: controlPoint.responsible.email,
          });
        }
        if (controlPoint.executor) {
          this.localControlPoint.executor_id = controlPoint.executor.id;
          this.executorsForSelect.push({
            prop: controlPoint.executor.id,
            displayText: controlPoint.executor.full_name,
            searchText: controlPoint.executor.email,
          });
        }
        if (controlPoint.organization) {
          this.localControlPoint.fnd_organization_id = controlPoint.organization.id;
          this.organizationsForSelect.push({
            prop: controlPoint.organization.id,
            displayText: controlPoint.organization.name,
            searchText: controlPoint.organization.name,
          });
        }
      }
    },
    setFieldState(fieldName, state) {
      this.isFieldInputDisabled[fieldName] = state;
    },
    setRelationAddFieldState(state=false) {
      this.isRelationAddFieldDisabled = state;
    },
    resetRelationAddField() {
      this.relativeControlPoint = undefined;
      this.controlPointsForSelect = [];
    },
    setDelegateFieldState(state=false) {
      this.isDelegateFieldDisabled = state;
    },
    resetDelegateField() {
      this.delegateUser = undefined;
      this.delegatesForSelect = [];
    },
    getLocalControlPointChanges() {
      if (!this.isChanged) return {};
      let result = {};
      this.availableFields.forEach(key => {
        if (this.localControlPoint[key] !== this.controlPoint[key]) {
          result[key] = this.localControlPoint[key];
        }
      });
      return result;
    },
    setMessage(message) {
      this.message = Object.assign({}, message);
    },
    resetMessage() {
      this.message = {
        id: null,
        comment: '',
        file: null,
      }
    },
    openFileLink(url) {
      window.open(url, '_blank');
    },
    async onFndSearch(text) {
      [this.fndsForSelect, this.fndsForSelectRaw] = await this.getAutocompleteData('/v1/fnd/list', text, 'id', 'code', (item) => item.code, ['leader']);
    },
    async onResponsibleSearch(text) {
      const autocompleteApiPath = `/v1/events/${this.event.id}/employees/list`;
      let autocompleteFilter = text;
      autocompleteFilter = `${autocompleteFilter}&fnd_id=${this.localControlPoint.fnd_id}`;
      autocompleteFilter = `${autocompleteFilter}&organization_id=${this.localControlPoint.fnd_organization_id}`;
      autocompleteFilter = `${autocompleteFilter}&role=leader`;
      [this.responsiblesForSelect] = await this.getAutocompleteData(autocompleteApiPath, autocompleteFilter,
        'id', 'email', (item) => `${item.full_name} <${item.email}>`);
    },
    async onExecutorSearch(text) {
      const autocompleteApiPath = `/v1/events/${this.event.id}/employees/list`;
      let autocompleteFilter = text;
      autocompleteFilter = `${autocompleteFilter}&fnd_id=${this.localControlPoint.fnd_id}`;
      autocompleteFilter = `${autocompleteFilter}&organization_id=${this.localControlPoint.fnd_organization_id}`;
      autocompleteFilter = `${autocompleteFilter}&role=leader`;
      [this.executorsForSelect] = await this.getAutocompleteData(autocompleteApiPath, autocompleteFilter,
        'id', 'email', (item) => `${item.full_name} <${item.email}>`);
    },
    async onDelegateSearch(text) {
      const autocompleteApiPath = `/v1/events/${this.event.id}/employees/list`;
      let autocompleteFilter = text;
      autocompleteFilter = `${autocompleteFilter}&fnd_id=${this.localControlPoint.fnd_id}`;
      autocompleteFilter = `${autocompleteFilter}&organization_id=${this.localControlPoint.fnd_organization_id}`;
      autocompleteFilter = `${autocompleteFilter}&role=employee`;
      [this.executorsForSelect] = await this.getAutocompleteData(autocompleteApiPath, autocompleteFilter,
        'id', 'email', (item) => `${item.full_name} <${item.email}>`);
    },
    async onControlPointSearch(text) {
      const autocompleteApiPath = `/v1/projects/${this.project.id}/control-points/list`;
      [this.controlPointsForSelect] = await this.getAutocompleteData(autocompleteApiPath, text, 'id', 'name');
    },
    async onOrganizationSearch(text) {
      const autocompleteApiPath = `/v1/fnd/organizations/list`;
      [this.organizationsForSelect] = await this.getAutocompleteData(autocompleteApiPath, text, 'id', 'name');
    },
    async fillExecutorAndResponsible() {
      if (this.isEditing) return;
      if (!this.localControlPoint.fnd_organization_id || !this.localControlPoint.fnd_id) return;
      let requestData = [];
      try {
        requestData = await executeApiGetRequest(`/v1/events/${this.event.id}/employees/list`, {
          fnd_id: this.localControlPoint.fnd_id,
          organization_id: this.localControlPoint.fnd_organization_id,
          role:'leader'
        });
      } catch (err) {
        this.$toasted.error(err.message);
      }
      if (requestData.data.length === 0) {
        this.localControlPoint.executor_id = undefined;
        this.localControlPoint.responsible_id = undefined;
        return;
      };
      const user = requestData.data[0];
      this.localControlPoint.responsible_id = user.id;
      this.responsiblesForSelect.push({
        prop: user.id,
        displayText: user.full_name,
        searchText: user.email,
      });
      this.localControlPoint.executor_id = user.id;
      this.executorsForSelect.push({
        prop: user.id,
        displayText: user.full_name,
        searchText: user.email,
      });
    },
    async addRelation() {
      if (!this.permissionsStatus.isControlPointUpdateAllowed) return;
      if (!this.relativeControlPoint) return;
      try {
        await this.addInfluenceToControlPoint({
          controlPointID: this.controlPoint.id,
          relation: this.relativeControlPoint
        });
        this.$toasted.success('Зависимость добавлена');
      } catch (err) {
        this.$toasted.error(err.message);
      }
      this.setRelationAddFieldState(true);
      this.resetRelationAddField();
    },
    async addControlPoint() {
      if (this.localControlPoint.responsible_id !== undefined ||
          this.localControlPoint.fnd_id !== undefined ||
          this.localControlPoint.executor_id !== undefined ||
          this.localControlPoint.fnd_organization_id !== undefined) {
        let isError = false;
        if (!this.localControlPoint.fnd_id) {
          this.$toasted.error("Необходимо назначить ФНД");
          isError = true;
        }
        if (!this.localControlPoint.fnd_organization_id) {
          this.$toasted.error("Необходимо назначить организацию");
          isError = true;
        }
        if (!this.localControlPoint.executor_id) {
          this.$toasted.error("Необходимо назначить исполнителя");
          isError = true;
        }
        if (!this.localControlPoint.responsible_id) {
          this.$toasted.error("Необходимо назначить ответственого");
          isError = true;
        }
        if (isError) return
      }
      try {
        await this.createControlPoint(this.localControlPoint);
        this.switchControlPointModal();
        this.$toasted.success('Контрольная точка добавлена');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async changeControlPoint() {
      if (this.localControlPoint.responsible_id !== undefined ||
          this.localControlPoint.fnd_id !== undefined ||
          this.localControlPoint.executor_id !== undefined ||
          this.localControlPoint.fnd_organization_id !== undefined) {
        let isError = false;
        if (!this.localControlPoint.fnd_id) {
          this.$toasted.error("Необходимо назначить ФНД");
          isError = true;
        }
        if (!this.localControlPoint.fnd_organization_id) {
          this.$toasted.error("Необходимо назначить организацию");
          isError = true;
        }
        if (!this.localControlPoint.executor_id) {
          this.$toasted.error("Необходимо назначить исполнителя");
          isError = true;
        }
        if (!this.localControlPoint.responsible_id) {
          this.$toasted.error("Необходимо назначить ответственого");
          isError = true;
        }
        if (isError) return
      }
      try {
        await this.updateControlPoint(this.localControlPoint);
        this.$toasted.success('Контрольная точка обновлена');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    removeControlPoint() {
      this.$toasted.info("Удалить контрольную точку?", { action: [{
        text: "Да",
        onClick: (e, toastObject) => {
          this.removeControlPointRequest();
          toastObject.goAway(0);
        },
      }, {
        text: "Нет",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        },
      }]});
    },
    async removeControlPointRequest() {
      try {
        await this.deleteControlPoint(this.localControlPoint.id);
        this.switchControlPointModal();
        this.$toasted.success('Контрольная точка удалена');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    deleteRelation(relativeControlPointID) {
      this.$toasted.info("Удалить связь?", { action: [{
        text: "Да",
        onClick: (e, toastObject) => {
          this.deleteRelationRequest(relativeControlPointID);
          toastObject.goAway(0);
        },
      }, {
        text: "Нет",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        },
      }]});
    },
    async deleteRelationRequest(relativeControlPointID) {
      if (!this.permissionsStatus.isControlPointUpdateAllowed) return;
      try {
        await this.deleteInfluenceFromControlPoint({
          controlPointID: this.controlPoint.id,
          relation: relativeControlPointID
        });
        this.$toasted.success('Зависимость удалена');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async changeControlPointStatus() {
      if (this.localControlPoint.execution_status === this.controlPoint.execution_status) return;
      if (!(this.permissionsStatus.isControlPointAllStatusAllowed ||
        this.permissionsStatus.isControlPointStatusAllowed ||
        this.permissionsStatus.isControlPointUpdateAllowed)) return;
      try {
        const resp = await this.setControlPointStatus({
          controlPointID: this.controlPoint.id,
          status: this.localControlPoint.execution_status,
        });
        this.$toasted.success(resp.data.message);
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async delegateExecution() {
      if (!this.delegateUser) return
      try {
        await this.delegateControlPoint({
          controlPointID: this.controlPoint.id,
          user_id: this.delegateUser,
        });
        this.$toasted.success('Исполнение делегировано');
      } catch (err) {
        this.$toasted.error(err.message);
      }
      this.setDelegateFieldState(true);
    },
    async addControlPointRequest() {
      if (!this.isControlPointRequestAllowed) return;
      try {
        await this.createControlPointRequest({
          control_point_id: this.controlPoint.id,
          changes: this.getLocalControlPointChanges(),
        });
        this.$toasted.success('Заявка создана');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async createNewMessage() {
      if (this.message.comment.length === 0) return
      try {
        const newAttachment = await this.createAttachment({
          attached_to_type: 'control_points',
          attached_to_id: this.controlPoint.id,
          comment: this.message.comment,
        });
        if (!!this.message.file) {
          await this.uploadFile({
            file: this.message.file,
            entityID: newAttachment.id,
            entityType: 'attachments',
            fileType: 'document'
          });
        }
        this.getControlPointByID(this.controlPoint.id);
        this.resetMessage();
        this.$toasted.success('Сообщение отправлено');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async updateMessage() {
      try {
        await this.updateAttachment({
          id: this.message.id,
          comment: this.message.comment,
        });
        this.getControlPointByID(this.controlPoint.id);
        this.resetMessage();
        this.$toasted.success('Сообщение обновлено');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    deleteMessage(messageID) {
      this.$toasted.info("Удалить сообщение?", { action: [{
        text: "Да",
        onClick: (e, toastObject) => {
          this.deleteMessageRequest(messageID);
          toastObject.goAway(0);
        },
      }, {
        text: "Нет",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        },
      }]});
    },
    async deleteMessageRequest(messageID) {
      if (this.message.id === messageID) this.resetMessage();
      try {
        await this.deleteAttachment(messageID);
        this.getControlPointByID(this.controlPoint.id);
        this.$toasted.success('Сообщение удалено');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
  mounted() {
    window.onscroll = function () { window.scrollTo(0, 0); };
  },
  beforeDestroy() {
    window.onscroll = undefined;
  },
  watch: {
    controlPoint: {
      immediate: true,
      handler(to) {
        this.setLocalControlPoint(to);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.control_point {
  z-index: 100;
  position: fixed;
  left: 0;
  height: 100%;
  width: 100%;
  overflow-y: scroll;

  &-overlay {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background: #000;
    opacity: 0.8;
  }

  &-card {
    z-index: 101;
    position: relative;
    left: 50%;
    margin-top: 100px;
    margin-bottom: 100px;
    padding: 20px;
    width: 700px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 10px;
    transform: translateX(-50%);

    .card {

      &-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;

        .title {

          &-text {
            width: 480px;
          }

          &-action {
            width: 160px;
            height: 31px;
            align-self: flex-start;
            background: $primary;
            color: #fff;
            border: 1px solid $primary;
            border-radius: 5px;
            font-size: 18px;
            transition: color ease-in-out .2s,
                        border ease-in-out .2s,
                        background ease-in-out .2s;

            &:hover {
              color: $primary;
              background: #fff;
              cursor: pointer;
            }

            &--delete {
              background: #fff;
              color: $secondary;
              border: 1px solid $secondary;

              &:hover {
                color: #fff;
                background: $secondary;
                cursor: pointer;
              }

            }

          }

        }

      }

      &-tags {
        margin: 15px 0;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
      }

      &-discussion {
        margin-top: 20px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;

        .discussion {

          &-title {
            margin-bottom: 10px;
            font-size: 16px;
          }

          &-input {

            .input {

              &-buttons {
                margin-top: 10px;
                display: flex;
                justify-content: flex-start;
                align-self: center;

                > div {
                  box-sizing: border-box;

                  &:not(:first-child) {
                    margin-left: 10px;
                  }

                }

              }

            }

          }

          &-messages {
            @include scroll-view(200px);
            margin-top: 20px;
            padding-right: 20px;
          }

          &-message {

            &:not(:first-child) {
              margin-top: 20px;
            }

            .message {

              &-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
              }

              &-sender {
                color: $primary;
                font-size: 14px;
              }

              &-content {
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
              }

              &-text {
                margin-top: 5px;
                margin-right: 10px;
              }

              &-actions {
                margin-left: auto;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;

                > svg {
                  margin-left: 10px;
                }

              }

            }

          }

        }

      }

      &-body {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;

        .body-block {
          width: 160px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          .card {

            &-info {
              width: 100%;

              .info {

                &-row {
                  margin-top: 15px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: flex-start;

                  &:first-child {
                    margin-top: 0;
                  }

                }

                &-title {
                  margin-top: 2px;
                  margin-right: 20px;
                  min-width: 90px;
                  max-width: 90px;
                }

                &-value {
                  width: 370px;
                }

              }

            }

            &-relations {
              max-width: 100%;
              width: 100%;

              &:not(:first-child) {

                .relations-title {
                  margin-top: 10px;
                }

              }

              .relation {
                box-sizing: border-box;
                margin-bottom: 5px;
                padding: 5px;
                min-height: 25px;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                color: $primary;
                border: 1px solid $primary;
                border-radius: 5px;
                transition: color      ease-in-out .2s,
                            border     ease-in-out .2s,
                            background ease-in-out .2s;

                &:hover {
                  color: #fff;
                  background: $primary;
                  border: 1px solid $primary;
                  cursor: pointer;
                }

                &--delete {

                  &:hover {
                    color: #fff;
                    background: $secondary;
                    border: 1px solid $secondary;
                    cursor: pointer;
                  }

                }

              }

              .relations {

                &-title {
                  margin-bottom: 5px;
                  color: $primary;
                }

                &-list {
                  overflow-y: scroll;
                  scrollbar-width: none;
                  -ms-overflow-style: none;

                  &::-webkit-scrollbar {
                    display: none;
                  }

                }

                &-action {
                  box-sizing: border-box;
                  margin-bottom: 15px;
                  width: 100%;
                  height: 20px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  color: #000;
                  border: 1px dotted $primary;
                  border-radius: 5px;
                  font-size: 12px;
                  transition: color      ease-in-out .2s,
                              border     ease-in-out .2s,
                              background ease-in-out .2s;

                  &:hover {
                    color: #fff;
                    background: $primary;
                    border: 1px solid $primary;
                    cursor: pointer;
                  }

                }

                &-input {
                  margin-bottom: 15px;
                }

              }

            }

            &-user {

              .user {
                margin-bottom: 15px;

                &:hover {
                  cursor: pointer;
                }

                &-title {
                  margin-bottom: 5px;
                  color: $primary;
                }

                &-action {
                  box-sizing: border-box;
                  margin-top: -5px;
                  margin-bottom: 15px;
                  width: 100%;
                  height: 20px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  color: #000;
                  border: 1px dotted $primary;
                  border-radius: 5px;
                  font-size: 12px;
                  transition: color      ease-in-out .2s,
                              border     ease-in-out .2s,
                              background ease-in-out .2s;

                  &:hover {
                    color: #fff;
                    background: $primary;
                    border: 1px solid $primary;
                    cursor: pointer;
                  }

                }

                &-input {
                  margin-top: -4px;
                  margin-bottom: 15px;
                }

              }

            }

          }

          &:first-child {
            margin-right: 20px;
            width: 480px;
          }

        }

      }

    }

  }

}
</style>
